export default __webpack_public_path__ + "static/media/zoho.fabca1ac.svg";